export default "__VITE_ASSET__DFCK3llF__"